import {
  Badge,
  Card,
  Center,
  Group,
  Loader,
  SimpleGrid,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { useSites } from "@/api/queries";
import { ErrorBanner } from "@/components/ErrorBanner";

export function SitesPage() {
  const [search, setSearch] = useState("");
  const { data, error, isLoading } = useSites({ search: search.trim() || undefined });

  return (
    <Stack>
      <Group justify="space-between" wrap="nowrap">
        <Title order={1}>Sites</Title>
        <TextInput
          placeholder="Search sites"
          leftSection={<IconSearch size={16} />}
          value={search}
          onChange={(event) => setSearch(event.currentTarget.value)}
          w={280}
        />
      </Group>

      {error && <ErrorBanner error={error} />}

      {isLoading ? (
        <Center py="xl">
          <Loader />
        </Center>
      ) : data && data.items.length > 0 ? (
        <>
          <Text c="dimmed" size="sm">
            {data.page.total} site{data.page.total === 1 ? "" : "s"}
          </Text>
          <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }}>
            {data.items.map((site) => (
              <Card
                key={site.id}
                component={Link}
                to={`/sites/${site.slug}`}
                withBorder
                shadow="sm"
                padding="lg"
                radius="md"
              >
                <Group justify="space-between" mb="xs">
                  <Text fw={600} size="lg" lineClamp={1}>
                    {site.display_name}
                  </Text>
                  <Badge
                    color={site.status === "active" ? "green" : "gray"}
                    variant="light"
                  >
                    {site.status}
                  </Badge>
                </Group>
                <Text c="dimmed" size="sm">
                  {site.slug}
                </Text>
                <Text c="dimmed" size="xs" mt="xs">
                  {site.timezone}
                </Text>
              </Card>
            ))}
          </SimpleGrid>
        </>
      ) : (
        <Text c="dimmed">
          {search
            ? `No sites match “${search}”.`
            : "No sites yet. Ask an operator to onboard one."}
        </Text>
      )}
    </Stack>
  );
}
